<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="ic_control_rstart_on" viewBox="0 0 16 16"><g id="그룹_108305" transform="translate(3.5 3)"><path id="패스_1137" d="M2291.055 3059.419a4.553 4.553 0 1 0 3.942-6.82 4.508 4.508 0 0 0-4.1 2.582" style="fill:none;stroke:#2c59d9;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px" transform="translate(-2290.551 -3051.995)" fill="currentColor"/><path id="패스_1138" d="M2306.4 3052.3v3.5h3.5" style="fill:none;stroke:#2c59d9;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px;stroke-linejoin:round" transform="translate(-2306.4 -3052.3)" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-control-restart',
});
</script>
